module.exports = __webpack_public_path__ + "media/30th_anniversary_sweepstakes/fastweb-30th-scholarship-anniversary-sweepstakes-lockup-header-07ec5b6e.png";